import script from "./ObjectElement.vue?vue&type=script&lang=js"
export * from "./ObjectElement.vue?vue&type=script&lang=js"

import "./ObjectElement.vue?vue&type=style&index=0&id=63b9d140&lang=scss"

const __exports__ = script;

export default __exports__